// extracted by mini-css-extract-plugin
export default {"FullPage":"Room_FullPage__djLhr","Card":"Room_Card__nNw1+"};